import moment from 'moment';
import BaseDetails from '@/store/modules/base.details';
import BaseItemsPaginated from '@/store/modules/base.items.paginated';
import { MechanicInstallation } from '@/types';
import { AsyncModule } from 'vuex-async-mutations';

interface InstallationsState {
  selectedDate: number | null;
}

export const module = {
  namespaced: true,

  async: true,

  state: {
    selectedDate: null,
  },

  modules: {
    details: BaseDetails<MechanicInstallation>('/installations', 'id'),
    items: BaseItemsPaginated<MechanicInstallation>('/installations', 'id'),
  },

  getters: {
    ['selectedDate'](state) {
      return state.selectedDate ?? Date.now();
    },

    ['installations'](state, getters) {
      return () => getters['page'](1);
    },
  },

  mutations: {
    ['setDate'](state, date: number) {
      state.selectedDate = date;
    },
  },

  actions: {
    ['fetch:byDate']({ dispatch, getters }) {
      const date = moment(getters['selectedDate']);
      const year = date.year();
      const month = date.month() + 1;
      const day = date.date();

      return dispatch('fetch:all:page', {
        perPage: 500,
        params: { year, month, day },
      });
    },

    ['fetch:all']({ dispatch }) {
      return dispatch('fetch:all:page', {
        perPage: 1000,
      });
    },
  },
} as AsyncModule<InstallationsState, any>;

export default module;
